import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_2 = { class: "dialog-footer" }

import { ref } from "vue";
import type { FormInstance } from "element-plus";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import notification from "@/core/plugins/notification";
import EventsServices from "../../../services/EventsServices";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCategory',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: emits }) {



const formData = ref<any>({
  key: "",
});
const keys = ref<any>([]);
const languages = ref<any>({});
const dialogRef = ref(false);
const isLoading = ref(false);
const ruleFormRef = ref<FormInstance>();
const show = (_keys: any) => {
  dialogRef.value = true;
  keys.value = _keys;
};

const handleKeypress = (event) => {
  const char = String.fromCharCode(event.keyCode);
  if (!/[a-zA-Z0-9]/.test(char)) {
    event.preventDefault();
  }
};

const submit = async () => {
  if (!ruleFormRef.value) return;
  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;
  isLoading.value = true;
  try {
    formData.value.languages = languages.value;
    formData.value.key = formData.value.key.trim();
    if (
      formData.value.languages &&
      !Object.keys(formData.value.languages).includes("en-us")
    ) {
      throw new Error("English translation is required");
    }
    await EventsServices.updateShopCategory(formData.value);
    reset();
    dialogRef.value = false;
    emits("submit");
    notification.success();
  } catch (error) {
    console.error("Validation failed:", error);
    notification.danger(error);
  }
  isLoading.value = false;
};

const reset = () => {
  formData.value.key = "";
  languages.value = {};
  ruleFormRef.value?.resetFields();
};

const rules = {
  key: [
    { required: true, message: "Please input the key", trigger: "blur" },
    { min: 3, max: 20, message: "Length should be 3 to 20", trigger: "blur" },
    {
      validator: (rule: any, value: string, callback: any) => {
        if (keys.value.includes(value)) {
          callback(new Error("Key must be unique"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogRef).value = $event)),
    title: _ctx.$t('fields.addCategory'),
    width: "800",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogRef.value = false)),
          disabled: isLoading.value,
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: submit,
          loading: isLoading.value,
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.confirm")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: formData.value,
        rules: rules,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.key'),
            prop: "key",
            class: "fw-bold"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.key,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.key) = $event)),
                placeholder: "Enter key",
                disabled: isLoading.value,
                onKeypress: handleKeypress
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _hoisted_1,
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("title.translation")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LanguageTypes).all, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "row row-cols-2"
            }, [
              _createVNode(_component_el_form_item, {
                label: item.name + ' (' + item.code + ')',
                prop: "languages"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: languages.value[item.code],
                    "onUpdate:modelValue": ($event: any) => ((languages.value[item.code]) = $event),
                    placeholder: "Enter translation",
                    disabled: isLoading.value
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 2
              }, 1032, ["label"])
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})